import React from 'react'
import { Row } from 'react-bootstrap'

const ExperienceLayout = (props) => {
  return (
    <div data-aos="fade-up" className='w-75 mx-auto'>
        <h3 className='display-6'> {props.designation}</h3>
        <Row>
        <div className="col-md-6">
            <p>{props.institution}</p>
        </div>
        <div className="col-md-6">
            <p>{props.duration}</p>
        </div>
        </Row>
            <small>{props.address}</small>
        <hr/>   
    </div>
  )
}

export default ExperienceLayout